import React from 'react'
import './chatWindow.scss'
// import { ButtonBack } from '../../../components/newButton/newButton'
import Loading from '../loading/loading'
import * as emailjs from 'emailjs-com'
import { Mutation, Query } from "react-apollo"
import { CreateChat, allChats } from '../../queries/chat'
import { GraphQLClient } from 'graphql-request'
import { endpoint, websocket } from '../../queries/endpoint'
import ErrorM from '../ErrorMessange/errormenssage'
import ScrollToBottom from 'react-scroll-to-bottom'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faGrin } from '@fortawesome/free-solid-svg-icons'
import Picker from 'emoji-picker-react';
// import { thisExpression } from '@babel/types'

export default class proposeDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingChat: true,
            chatErr: null,
            ranked: false,
            chatList: [],
            description: '',
            emojishow: false
        }

        const webSocket = new WebSocket(websocket, 'graphql-subscriptions')

        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if(cache) {
          this.playerId = cache.user.player.id  
        } else {
            window.location.href = '/login'
        }

        try {
            webSocket.onopen = (event) => {
            const message = {
                type: 'init',
                payload: {
                    Authorization: `Bearer ${cache.token}`
                }
            }

            webSocket.send(JSON.stringify(message))

            const subscription = {
                id: '1',
                type: 'subscription_start',
                query: `
            subscription allChats {
                Chat(
                    filter: {
                      mutation_in: CREATED
                      node: {
                        propose: {
                          id: "${this.props.propose.id}"
                        }
                      }
                    }
                  ){
                  mutation
                  updatedFields
                  node {
                    id
                    description
                    status
                    from {
                      id
                    }
                    to {
                        id
                      }
                    propose {
                      id
                      date
                    }
                  }
                }
              }
            `
            }

            webSocket.send(JSON.stringify(subscription))

        }
    } catch {
        throw new Error()
    }

    try {
        webSocket.onmessage = (event) => {
            const data = JSON.parse(event.data)
            // console.log(event.data)
            switch (data.type) {
                case 'init_success': {
                    console.log('init_success, the handshake is complete')
                    break
                }
                case 'init_fail': {
                    console.log('init_fail returned from WebSocket server:', event)
                    break
                }
                case 'subscription_data': {
                    console.log('subscription data has been received', data)
                    // Object.assign({}, this.state.chatList, {
                    //     allChats: [data.node, ...this.state.chatList],
                    // })
                    // this.state.chatList.push(data.node)
                    var allChats = this.state.chatList
                    allChats.push(data.payload.data.Chat.node)
                    // console.log(allChats)
                    this.setState({ chatList: allChats })

                    break
                }
                case 'subscription_success': {
                    console.log('subscription_success')
                    break
                }
                case 'subscription_fail': {
                    console.log('subscription_fail returned from WebSocket server', event)
                    break
                }
                case 'error': {
                    console.log("ERROOO: ", data)
                    break
                }
                default:
                    console.log(data.type)
                    break
            }
        }
    } catch {
        throw new Error()
    }

    }

    componentDidMount() {
        // console.log("componentWillUpdate")
        const webSocket = new WebSocket(websocket, 'graphql-subscriptions')
        webSocket.onmessage = (event) => {
            const data = JSON.parse(event.data)
            console.log("componentWillUpdate", event.data)
            switch (data.type) {
                case 'init_success': {
                    console.log('init_success, the handshake is complete')
                    break
                }
                case 'init_fail': {
                    console.log('init_fail returned from WebSocket server:', event)
                    break
                }
                case 'subscription_data': {
                    console.log('subscription data has been received', data)
                    var allChats = this.state.chatList
                    allChats.push(data.payload.data.Chat.node)
                    this.setState({ chatList: allChats })
                    // if (allChats !== undefined) this.readMessage(allChats)
                    // setTimeout(this.readMessage(allChats), 5000)
                    break
                }
                case 'subscription_success': {
                    console.log('subscription_success')
                    break
                }
                case 'subscription_fail': {
                    console.log('subscription_fail returned from WebSocket server')
                    break
                }
                case 'error': {
                    console.log("ERROOO: ", data)
                    break
                }
                default:
                    console.log(data.type)
                    break
            }
        }

        // setTimeout(this.readMessage(), 5000)
    }

    setInput = event => {
        console.log(event)
        this.setState({ description: event.target.value, chatErr: null });
        return event.target.value
    } //_setInput

    sendMenssage = (CreateChat, e) => {
        e.preventDefault()

        
        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache && this.state.description) {

            const date = new Date()
            const now = date.toISOString()

            CreateChat({
                variables: {
                    description: this.state.description,
                    fromId: this.playerId,
                    proposeId: this.props.propose.id,
                    status: false,
                    toId: this.props.otherUser.id,
                    date: now
                }
            }).then(
                res => {
                    if (res.error) throw new Error()
                    const client = new GraphQLClient(endpoint, {
                        headers: {
                            Authorization: `Bearer ${cache.token}`,
                        },
                    })

                    // console.log('chat', this.props.propose.anuncios ? this.props.propose.anuncios.skills.name : this.props.propose.skill)
                    client.request(`
                            mutation{
                            createNotification(
                            playerId: "${this.props.otherUser.id}",
                            title: "Mensagem recebida!",
                            description: "Você recebeu uma nova mensagem da proposta ${this.props.propose.anuncios ? this.props.propose.anuncios.skills.name : this.props.propose.skill}.",
                            link: "/perfil/proposedetails/${this.props.proposeId}",
                            status: false,
                            date: "${now}"
                            ){
                            id
                            title
                            }
                            } `).then(
                        res => {
                            var template_params2 = {
                                "email": this.props.otherUser.email,
                                "title": "Mensagem recebida!",
                                "name": this.props.otherUser.name,
                                "message": `Você recebeu uma mensagem! Acesse a proposta ${this.props.propose.anuncios ? this.props.propose.anuncios.skills.name : this.props.propose.skill} no seu perfil na Oito e responda assim que possível.`
                            }

                            emailjs.send('noreply', 'default', template_params2, "user_IagwdTtEr3AVRdLhxkyKc")
                                .then((response) => {
                                    console.log('SUCCESS!', response.status, response.text)
                                    this.form = {}
                                    // this.updateChat()//ver esse reaload
                                }, function (error) {
                                    console.log('FAILED...', error)
                                });

                            console.log('mensagem enviada') //poe uma snackbar
                            document.getElementById('chatInput').value = ''
                            this.setState({ description: "", emojishow: false })
                            // e.preventDefault()
                            // this.refetch()

                        }
                    )
                }
            )
        } else {
            this.setState({
                chatErr: <ErrorM color="danger" content="Não é possóvel enviar uma mensagem vazia" />
            })
        }
    }

    readMessage() {

        let list = []

        if (this.state.chatList.length > 0 && list !== this.state.chatList) {

            list = this.state.chatList

            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            // console.log("readmessage")
            // console.log(list)
            if (list.length > 0) {
                list.map(m => {
                    if (!m.status && m.from.id === this.playerId) {
                        // console.log(m)

                        client.request(`
                    mutation{
                        updateChat(
                          id: "${m.id}"
                          status: true
                        ){
                          id
                          description
                          date
                          status
                          from {
                            id
                            name
                          }
                          to {
                            id
                            name
                          }
                          propose {
                            id
                            date
                          }
                        }
                      }
                    `).then(
                            res => {

                                // this.refetch()
                                // return console.log(res)
                                return null
                            }
                        ).catch(err => console.log(err))
                        // salvara no banco
                    }
                    return null
                })
            }
        }
    }

    componentWillUpdate() {
        this.readMessage()
    }

    onEmojiClick = (event, emojiObject) => {
        event.preventDefault()
        console.log(emojiObject)
        const string = this.state.description.concat(emojiObject.emoji)
        this.setState({ description: string, chatErr: null });
        return string
        // setChosenEmoji(emojiObject);
    }

    render() {

        const { propose, blocked } = this.props

        const MessageListView = ({ data, playerId, proposeId }) => {
            if (data) {
                // console.log(data)
                return data.map(message => <MessageItem key={message.id} message={message} playerId={playerId} proposeId={proposeId} />)
            } else {
                return null
            }
            // data ? data.map(message => <MessageItem key={message.id} message={message} playerId={playerId} />) : null
            // console.log('MessageListView', data)
            // return null
        }

        const MessageItem = ({ message, playerId, proposeId }) => (
            // console.log(proposeId)
            (message.from.id !== playerId && message.propose.id === proposeId) ?
                <div className="msgReceived col-xs-10"><p>{message.description} <span>{dayjs(message.date).format("DD/MM hh:mm")}</span></p></div> :
                <div className="msgSend col-xs-10 col-xs-offset-2"><div>{message.description} <span>{dayjs(message.date).format("DD/MM hh:mm")} <FontAwesomeIcon icon={faCheck}  style={{ color: message.status ? "#8C71D9" : "#ffffff" }}/></span></div></div>
        )

        // window.setTimeout(this.readMessage, 5000)

        return (
            <Query query={allChats} variables={{ id: propose.id }}>
                {({ loading, error, data }) => {
                    if (loading) return <Loading />
                    if (error) return <p>{error.message}</p>

                    // this.refetch = refetch
                    // console.log(data)

                    if (data.allChats.length > 0 && this.state.chatList.length === 0) this.setState({ chatList: data.allChats })
                    // console.log(this.state.chatList.map(a => a.date))

                    if (data.allChats) {

                        let resposta = []

                        for (let i = 0; i < data.allChats.length; i++) {
                            if (i === 0 && data.allChats[i].to.id === this.playerId) {
                                const date1 = dayjs(data.allChats[i].date)
                                const date2 = dayjs(propose.date)
                                resposta.push(date1.diff(date2, "minute"))
                            } else if (data.allChats[i].to.id === this.playerId) {
                                const date1 = dayjs(data.allChats[i].date)
                                const date2 = dayjs(data.allChats[i - 1].date)
                                resposta.push(date1.diff(date2, "minute"))
                            }
                        }
                        // console.log(resposta)
                        let md = 0
                        let media = null
                        if (resposta !== null && resposta.length > 0) {
                            resposta.map(r =>
                                md = md + r)
                            media = md / resposta.length
                        }
                        this.props.callbackFunctions(media)

                        return (
                            <div className="chat-box row">
                                <ScrollToBottom className="mensages col-xs-12" id="msgBox">
                                    <MessageListView data={this.state.chatList} playerId={this.playerId} proposeId={propose.id} />
                                </ScrollToBottom>

                                <form className="inputMsg col-xs-12">

                                    <input placeholder="Digite sua mensagem" type="text" name='description' id="chatInput" disabled={blocked} value={this.state.description} onInput={this.setInput} onClick={() => this.setState({ emojishow: false })} maxLength={140}>
                                    </input>

                                    {this.state.emojishow?
                                        <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh'}}>
                                            <div style={{position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh'}} onClick={() => this.setState({ emojishow: !this.state.emojishow })}></div>
                                            <div style={{position: 'absolute', bottom: '10px', left: '30%'}}><Picker onEmojiClick={this.onEmojiClick.bind(this)}/></div>
                                        </div> : null}

                                    <FontAwesomeIcon icon={faGrin} className="buttonemoji" onClick={() => this.setState({ emojishow: !this.state.emojishow })}/>

                                    <Mutation mutation={CreateChat}>
                                        {CreateChat => (
                                            <button type='submit' disabled={blocked} onClick={(e) => this.sendMenssage(CreateChat, e)}>
                                                <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
                                                    <path fill="#fff" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
                                                </svg>
                                            </button>
                                        )}
                                    </Mutation>
                                </form>
                                {this.state.chatErr}
                            </div>
                        )
                    } else {
                        return null
                    }
                }}
            </Query>)
    }
}
